// extracted by mini-css-extract-plugin
export default {"devicePairing":"DevicePairingPage__devicePairing-hA3g9","midHeader":"DevicePairingPage__midHeader-AbWlS"};